(ns frontend.ui.page.lp-portal.archive.filters-section.view
  (:require
   [common.util :as cu]
   [frontend.ui.page.lp-portal.archive.filters-section.style :as style]
   [frontend.ui.component.lp-portal.checkbox.view :as checkbox]
   [frontend.ui.page.lp-portal.report.util :as ru]
   [herb.core :refer [<class]]
   [frontend.ui.component.grid.view :as grid]
   [re-frame.core :as rf]
   [frontend.ui.page.lp-portal.archive.sub :as sub]
   [frontend.ui.page.lp-portal.archive.event :as event]
   [reagent.core :as r]))

(def years
  (-> (-> (js/Date.)
          (.getFullYear))
      (range 2004 -1)))

(def quarters
  (range 1 5))

(defn filters-section
  []
  (r/create-class
   {:component-did-mount #(rf/dispatch [::event/all-archive-reports])
    :reagent-render      (fn []
                           (let [funds @(rf/subscribe [::sub/archive-funds])
                                 years @(rf/subscribe [::sub/all-archived-reports-years])
                                 selected-quarters @(rf/subscribe [::sub/archive-filter-quarters])
                                 selected-year @(rf/subscribe [::sub/archive-filter-year])
                                 selected-fund-id @(rf/subscribe [::sub/archive-filter-fund-id])
                                 is-reset @(rf/subscribe [::sub/is-reset])
                                 only-one-fund? @(rf/subscribe [::sub/only-one-fund?])]
                             [:div
                              {:class (<class style/container)}
                              [:div
                               {:class (<class style/filters-container)}
                               (when-not only-one-fund?
                                 [:div
                                  {:class (<class style/filter-group-container)
                                   :style {:flex :3}}
                                  [:label
                                   {:class (<class style/form-group-label)}
                                   "Fund"]
                                  [:div
                                   {:class (<class style/dropdown-container)}
                                   [:select
                                    {:class     (<class style/dropdown)
                                     :value     (or selected-fund-id "")
                                     :on-change (fn [event]
                                                  (rf/dispatch [::event/archive-filter-fund-id
                                                                (-> event
                                                                    .-target
                                                                    .-value)]))}
                                    [:option {:value ""} "Any"]
                                    (->> funds
                                         (sort-by (fn [f]
                                                    (->> f
                                                         :fund/name
                                                         (cu/str-trim-lcase))))
                                         (map (fn [fund]
                                                [:option {:value (:db/id fund)} (:fund/name fund)]))
                                         (doall))]
                                   [:i.fas.fa-caret-down
                                    {:class (<class style/dropdown-caret)}]]])

                               [:div
                                [:label
                                 {:class (<class style/form-group-label)}
                                 "Quarter"]

                                [:div
                                 {:class (<class style/quarter-options)}
                                 (->>
                                  quarters
                                  (map (fn [quarter]
                                         ^{:key quarter}
                                         [:div
                                          {:class    (<class style/quarter-option)
                                           :on-click (fn [] (rf/dispatch [::event/toggle-archive-filter-quarter quarter]))}
                                          [checkbox/checkbox
                                           {:size-px 16
                                            :value   (contains? selected-quarters quarter)}]
                                          (str "Q" quarter)]))
                                  (doall))]]
                               [:div
                                {:class (<class style/filter-group-container)
                                 :style {:flex :2}}
                                [:label
                                 {:class (<class style/form-group-label)}
                                 "Year"]
                                [:div
                                 {:class (<class style/dropdown-container)}
                                 [:select
                                  {:class     (<class style/dropdown)
                                   :value     (or selected-year "")
                                   :on-change (fn [event]
                                                (rf/dispatch [::event/archive-filter-year
                                                              (-> event
                                                                  .-target
                                                                  .-value)]))}
                                  (when (> (count years) 1) [:option {:value ""} "Any"])
                                  (->> years
                                       (map (fn [year] [:option {:value year} year])))]
                                 [:i.fas.fa-caret-down
                                  {:class (<class style/dropdown-caret)}]]]]
                              (when-not is-reset
                                [:button
                                 {:class    (<class style/simple-button)
                                  :style    (when is-reset
                                              {:color        :#B5BBC2
                                               :border-color :#B5BBC2
                                               :cursor       :default})
                                  :on-click (fn [] (rf/dispatch [::event/reset-archive-filters]))}
                                 "Clear filters"])]))}))
